import { createAsyncThunk } from '@reduxjs/toolkit';
import moment from 'moment';
import { selectUserActiveEmployerInfo } from 'store/user/selectors.js/user.selectors';
import { getActivityLogsForUserProjectDate } from '../services/getActivityLogsForUserProjectDate.service';
import { isShownInProjectFeed } from './fetchProjectActivityFeed.thunk';

/**
 * The viewer's local day `date` (YYYY-MM-DD) as UTC instants: its midnight
 * and the next one (a day of 23 or 25 hours on a daylight-saving change).
 * @param {string} date
 * @returns {{from: string, to: string}|null}
 */
export const localDayBounds = (date) => {
  const start = moment(date, 'YYYY-MM-DD', true);
  if (!start.isValid()) return null;
  return {
    from: start.clone().startOf('day').toISOString(),
    to: start.clone().add(1, 'day').startOf('day').toISOString(),
  };
};

/**
 * A user's activity on a project for the viewer's local day `date`: the
 * rows, without those of opening the project (an API from before it left
 * them out still sends them), and what the viewer may see of the images the
 * rows are about (`images`, by file permission id; empty from an API that
 * does not resolve them).
 */
export const fetchActivityLogsForUserProjectDate = createAsyncThunk(
  'activityLog/fetchForUserProjectDate',
  async ({ projectId, userId, date }, { getState }) => {
    const activeEmployerInfo = selectUserActiveEmployerInfo(getState());

    const data = await getActivityLogsForUserProjectDate({
      projectId,
      userId,
      date,
      ...localDayBounds(date),
      activeEmployerInfo,
    });

    return {
      items: (data?.items || []).filter(isShownInProjectFeed),
      images: data?.images || {},
    };
  }
);
